export enum SettingsUrlParts {
  Profile = 'profile',
  PersonalInfo = 'personal-info',
  SocialAccounts = 'social-accounts',
  Preferences = 'preferences',
  Courses = 'courses',
  Billing = 'billing',
  Invite = 'invite',
}

export const DEFAULT_SETTINGS_URL_PART = SettingsUrlParts.Profile;

export const SETTINGS_URL_PART_TO_NAME = {
  [SettingsUrlParts.Profile]: 'settings.profile',
  [SettingsUrlParts.PersonalInfo]: 'examdojo.settings.personal_info',
  [SettingsUrlParts.SocialAccounts]: 'examdojo.settings.social_accounts',
  [SettingsUrlParts.Preferences]: 'examdojo.settings.preferences',
  [SettingsUrlParts.Courses]: 'settings.courses',
  [SettingsUrlParts.Billing]: 'settings.billing',
  [SettingsUrlParts.Invite]: 'settings.invite',
};

export const SETTINGS_ROUTE_DATA_KEY = 'settingsPage';
